<template>
  <div v-bind:class="flipped ? 'flip-container flipped' : 'flip-container'">
    <div class="flipper">
      <div
        class="front"
        style="background-position: center;"
        v-bind:style="{
          backgroundImage: hasBack ? 'url(' + cc + ')' : 'url(' + cmd + ')',
        }"
      >
        <slot name="front"></slot>
        <div class="card">
          <img
            v-if="hasBack"
            class="frontFlipBtn"
            :src="rotateIconDark"
            v-on:click="flipped = true"
          />
          <img
            v-if="hasBack"
            class="frontFlipBtn img-top"
            :src="rotateIcon"
            v-on:click="flipped = true"
          />
        </div>
      </div>
      <div
        class="back"
        style="background-position: center;"
        v-bind:style="{
          backgroundImage: hasBack ? 'url(' + cc + ')' : 'url(' + cmd + ')',
        }"
      >
        <slot name="back"></slot>

        <div class="card">
          <img
            v-if="hasBack"
            class="frontFlipBtn"
            :src="rotateIconDark"
            v-on:click="flipped = false"
          />
          <img
            v-if="hasBack"
            class="frontFlipBtn img-top"
            :src="rotateIcon"
            v-on:click="flipped = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlipCard",
  props: ["hasBack"],
  data() {
    return {
      flipped: false,
      cmd: require("../assets/cmd.jpg"),
      cc: require("../assets/citizen-card.jpg"),
      rotateIcon: require("../assets/rotate.svg"),
      rotateIconDark: require("../assets/rotate-dark.svg"),
    };
  },
};
</script>

<style type="text/css" scoped>
img.frontFlipBtn,
img.backFlipBtn {
  position: absolute;
  right: -20px;
  bottom: -20px;
  color: #ffffff;
  cursor: pointer;
}

.card .img-top {
  display: none;
  position: absolute;
  z-index: 99;
}

.card:hover .img-top {
  display: inline;
}

i.backFlipBtn {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
}
.flip-container {
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  perspective: 1000;
}
.flip-container {
  min-height: 120px;
}
.flipper {
  -moz-transform: perspective(1000px);
  -moz-transform-style: preserve-3d;
  position: relative;
}
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.6s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.6s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.6s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.6s;
  -ms-transform-style: preserve-3d;
  transition: 0.6s;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  width: 100%;
}
.back {
  transform: rotateY(-180deg);
  position: absolute;
}
.flip-container.flipped .back {
  transform: rotateY(0deg);
}
.flip-container.flipped .front {
  transform: rotateY(180deg);
}
.front {
  z-index: 2;
}
</style>
